module.exports = __webpack_public_path__ + "img/offline_radio.971da053.svg";